import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../App";
import ScrollTopButton from "../ScrollTop";
import Calendar from "react-calendar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone, faIdBadge, faChartLine, faBook, faListCheck, faVideo, faPersonBiking, faCoins, faUserCheck } from "@fortawesome/free-solid-svg-icons";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import 'react-calendar/dist/Calendar.css';
import '../../styles/profile.css';
import SidebarProfile from "../SidebarProfile";
import profileUser from "../../Men Face Winkling.json"
import Lottie from "lottie-react";
import BrianAnimated from "../BrainAnimated";
import StonesLoader from "../Stones";
import Barcode from "react-barcode";
import SimpleLoader from "../SimpleLoader";

function Profile ({ style }) {
  const [authDetails, setAuthDetails] = useState({});
  const [myStats, setMyStats] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(new Date());

useEffect(() => {
  window.scrollTo(0, 0);

  const fetchData = async () => {
    setIsLoading(true);

    const token = localStorage.getItem('token');
    const axiosInstance = axios.create({
      baseURL: BASE_URL,
      headers: { Authorization: `Bearer ${token}` },
    });

    const delay = new Promise(resolve => setTimeout(resolve, 2000)); // ⏱️ تأخير 3 ثوانٍ

    try {
      const [authRes, statsRes] = await Promise.all([
        axiosInstance.get('/api/Auth'),
        axiosInstance.get('/api/my-statistics'),
        delay
      ]);

      setAuthDetails(authRes.data);
      setMyStats(statsRes.data);
    } catch (error) {
      console.error("Failed to fetch profile data", error);
    } finally {
      setIsLoading(false);
    }
  };

  fetchData();
}, []);


  const getProgressBarPathColor = (percentage) => {
    if (percentage < 40) return '#ef4444';
    if (percentage < 70) return '#f59e0b';
    return '#22c55e';
  };

  const videoPercentage = myStats.numberOfVideos ? Math.round((myStats.viewedVideos / myStats.numberOfVideos) * 100) : 0;
  const quizPercentage = myStats.numOfAllQuizzes ? Math.round((myStats.numOfMyQuizzes / myStats.numOfAllQuizzes) * 100) : 0;
  const degreePercentage = myStats.standardDegree ? Math.round((myStats.myDegrees / myStats.standardDegree) * 100) : 0;

  if (isLoading) {
   return (
 <div className={`main-loading ${style ? 'dark-mode' : ''}`}>
        <div className="loading-course">
        <SimpleLoader size="large" />
        </div>
      </div>
    );
  }
  const overallProgress = authDetails.progress || 0;
 const getMotivationalMessage = (percentage) => {
    if (percentage < 30) return "لسه في الأول، بس البداية قوية!";
    if (percentage < 70) return "شغل عالي ومجهود واضح، استمر!";
    if (percentage < 100) return "أنت على وشك توصل للقمة، برافو!";
    return "وصلت للقمة! إنجاز رائع!";
  };

  return (
    <>
      <div className={`profile-page ${style ? 'dark-mode' : ''}`}>
      <SidebarProfile />
        <main className="profile-main-content">
          <Container fluid>
            <div className="page-header">
              <div className="header-icon-wrapper">
                                <FontAwesomeIcon icon={faPersonBiking} />
              </div>
              <div className="header-text">
                <h1>ملفك الشخصي</h1>
                <p>يا هلا بيك يا {authDetails.fname}! هنا كل حاجة عن تقدمك وإنجازاتك.</p>
              </div>
            </div>

            <Row>
              <Col xl={8} lg={7} className="mb-4">
               <div className="progress-highlight-card">
  <div className="card-bg"></div>
  <div className="progress-text">
    <h5>تقدمك الإجمالي في الكورسات</h5>
    <p>{getMotivationalMessage(overallProgress)}</p>
  </div>
  <div className="progress-visual">
    <CircularProgressbar
      value={overallProgress}
      text={`${overallProgress}%`}
      strokeWidth={8}
      styles={buildStyles({
        pathColor: `rgba(255, 255, 255, ${overallProgress / 100 + 0.3})`,
        textColor: '#fff',
        trailColor: 'rgba(255, 255, 255, 0.15)',
        pathTransitionDuration: 1.5,
        pathTransition: 'stroke-dashoffset 1.5s ease 0s',
      })}
    />
  </div>
</div>
                <div className="stats-grid">
                  <div className="stat-card circular">
                    <div style={{ width: 100, height: 100 }}>
                      <CircularProgressbar value={degreePercentage} text={`${degreePercentage}%`} styles={buildStyles({ pathColor: getProgressBarPathColor(degreePercentage), textColor: style ? '#f9fafb' : '#111827', trailColor: style ? '#374151' : '#e5e7eb' })} />
                    </div>
                    <div className="stat-info">
                      <h5>متوسط درجاتك</h5>
                      <span>{myStats.myDegrees} / {myStats.standardDegree}</span>
                    </div>
                  </div>
                  <div className="stat-card circular">
                    <div style={{ width: 100, height: 100 }}>
                      <CircularProgressbar value={quizPercentage} text={`${quizPercentage}%`} styles={buildStyles({ pathColor: getProgressBarPathColor(quizPercentage), textColor: style ? '#f9fafb' : '#111827', trailColor: style ? '#374151' : '#e5e7eb' })} />
                    </div>
                    <div className="stat-info">
                      <h5>الكويزات اللي خلصتها</h5>
                      <span>{myStats.numOfMyQuizzes} / {myStats.numOfAllQuizzes}</span>
                    </div>
                  </div>
                  <div className="stat-card circular">
                    <div style={{ width: 100, height: 100 }}>
                      <CircularProgressbar value={videoPercentage} text={`${videoPercentage}%`} styles={buildStyles({ pathColor: getProgressBarPathColor(videoPercentage), textColor: style ? '#f9fafb' : '#111827', trailColor: style ? '#374151' : '#e5e7eb' })} />
                    </div>
                    <div className="stat-info">
                      <h5>الفيديوهات اللي شوفتها</h5>
                      <span>{myStats.viewedVideos} / {myStats.numberOfVideos}</span>
                    </div>
                  </div>
                </div>

                <div className="platform-stats-card">
                  <h4 className="card-header"><FontAwesomeIcon icon={faChartLine} /> إحصائياتك على المنصة</h4>
                  <div className="platform-stats-grid">
                    <div className="platform-stat-item">
                      <h6>الحصص اللي اشتريتها</h6>
                      <span>{myStats.numOfMyWeeks}</span>
                      <FontAwesomeIcon icon={faBook} className="bg-icon" />
                    </div>
                    <div className="platform-stat-item">
                      <h6>مجموع الأسئلة اللي حلتها</h6>
                      <span>{myStats.allSolvedQuizzes}</span>
                      <FontAwesomeIcon icon={faListCheck} className="bg-icon" />
                    </div>
                    <div className="platform-stat-item">
                      <h6>مجموع مشاهداتك للفيديوهات</h6>
                      <span>{myStats.numberOfWatchingVideos}</span>
                      <FontAwesomeIcon icon={faVideo} className="bg-icon" />
                    </div>
                    <div className="platform-stat-item">
                      <h6> النقط بتاعتك </h6>
                      <span>{authDetails.points || 0}</span>
                      <FontAwesomeIcon icon={faCoins} className="bg-icon" />
                    </div>
                    {/* <div className="platform-stat-item">
                      <h6>  عدد مرات حضورك أونلاين </h6>
                      <span>{authDetails.online_attends || 0}</span>
                      <FontAwesomeIcon icon={faUserCheck} className="bg-icon" />
                    </div> */}
                  </div>
                </div>
              </Col>
              
              <Col xl={4} lg={5} className="mb-4">
                <div className="user-info-card">
                  <div className="user-avatar">
                {/* <Lottie  animationData={profileUser} loop={true}/> */}
                <img  src="/images/man.png" loading="lazy" alt="user"/>
                
                  </div>
                  <h3>{authDetails.fname + ' ' + authDetails.lname}</h3>
                  <div className="user-contact">
                    <span><FontAwesomeIcon icon={faEnvelope} /> {authDetails.email}</span>
                    <span><FontAwesomeIcon icon={faPhone} /> {authDetails.phone}</span>
                    <span><FontAwesomeIcon icon={faIdBadge} /> ID: {authDetails.id}</span>
                  </div>
                  {/* <div className="barcode-container">
                <Barcode 
                    value={String(authDetails.id)}
                    width={5}     
                    height={60}   
                    displayValue={true} 
                    fontSize={14}     
                    margin={10}
                    background="transparent" 
                    lineColor="#333" 
                />
            </div> */}
                  {/* <Link to="/editinfo" className="edit-profile-btn">عدّل بياناتك</Link> */}
                </div>
                <div className="calendar-card">
                  <h4 className="card-header">مواعيدك</h4>
                  <Calendar onChange={setSelectedDate} value={selectedDate} />
                </div>
              </Col>
            </Row>

         
          </Container>
        </main>
      </div>
      <ScrollTopButton />
    </>
  );
}

export default Profile;